import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import * as Yup from 'yup';
import i18n from 'i18n-js';
import Grid from '@material-ui/core/Grid';
import { BaseModal } from 'components/UI';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'components/FormFields';
import { useDispatch, useSelector } from 'react-redux';
import { SubscriptionsActions } from 'state/modules/subscriptions';

const EditPeriods = ({ open, subscription, handleClick }) => {
  const formSchema = Yup.object().shape({
    periods_reserved: Yup.string().required(i18n.t('common.required_field')),
  });

  const [disableSubmit] = useState(
    subscription?.status?.includes(['COMPLETED', 'REJECTED', 'CANCELLED'])
  );

  const formRef = useRef(null);
  const dispatch = useDispatch();
  const { fetchingUpdateSubscription, fetchedUpdateSubscription } = useSelector(
    (state) => state.subscriptions
  );

  const onSubmit = () => {
    formRef.current.submitForm();
  };

  useEffect(() => {
    if (!fetchingUpdateSubscription && fetchedUpdateSubscription) {
      handleClick();
    }
  }, [fetchedUpdateSubscription, fetchingUpdateSubscription]); // eslint-disable-line

  return (
    <BaseModal
      size="sm"
      open={open}
      hasEnterButton
      hasCancelButton
      onEnter={onSubmit}
      onCancel={handleClick}
      enableCloseButton={false}
      handleClick={handleClick}
      loading={fetchingUpdateSubscription}
      title={i18n.t('actions.edit_periods')}
      enterButtonLabel={i18n.t('common.save')}
      disabledSubmit={disableSubmit}
    >
      <Formik
        innerRef={formRef}
        initialValues={{
          periods_reserved: subscription?.periods_reserved || '',
        }}
        onSubmit={(values) => {
          dispatch(SubscriptionsActions.fetchUpdateSubscription(subscription?.id, values));
        }}
        validationSchema={formSchema}
      >
        {({ handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Grid data-cy="edit-period" container spacing={2}>
              <Grid item xs={12}>
                <Field
                  type="text"
                  margin="none"
                  name="periods_reserved"
                  disabled={disableSubmit}
                  component={TextField}
                  label={i18n.t('subscriptions.periods')}
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </BaseModal>
  );
};

EditPeriods.propTypes = {
  open: PropTypes.bool.isRequired,
  subscription: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
};

EditPeriods.defaultProps = {
  open: false,
  subscription: {},
  handleClick: () => {},
};

export default EditPeriods;
